import angular from 'angular';
import reportPackageReport from './reportPackageReport';
import directive from './report-package-reports.directive';
import controller from './report-package-reports.controller';


export default angular.module('app.components.reports.packageReports.reportPackageReports', [
  reportPackageReport
])
  .directive('prReportPackageReports', directive)
  .controller('PRReportPackageReportsController', controller)
  .name;

console.log('app.components.reports.packageReports.reportPackageReports created');
